import colors from './colors';
import i18n from './i18n';
import createTheme from './create-theme';
export default createTheme({
  colors: colors,
  i18n: i18n
});